import { Injectable, Injector, Type } from '@angular/core';

import { ControlNamePropertyService } from './control-name-property.service';
import { ElementIdPropertyService } from './element-id-property.service';
import { ControlPropertyHandler } from './control-property-handler';
import { CascadeParentNamePropertyService } from './cascade-parent-name-property.service';
import { TemplateUrlPropertyService } from './template-url-property.service';
import { TemplateNamePropertyService } from './template-name-property.service';
import { DefaultPropertyService } from './default-property.service';

@Injectable({
  providedIn: 'root'
})
export class PropertyHandlerFactoryService {
  propertyTypedServices: Type<ControlPropertyHandler<any>>[] = [
    ControlNamePropertyService,
    CascadeParentNamePropertyService,
    ElementIdPropertyService,
    TemplateUrlPropertyService,
    TemplateNamePropertyService
  ];

  propertyServices: ControlPropertyHandler<any>[] = [];
  defaultPropertyService: DefaultPropertyService;

  constructor(private injector: Injector) {
    this.defaultPropertyService = this.injector.get(DefaultPropertyService);
    this.propertyServices = this.propertyTypedServices.map((s) => this.injector.get(s));
  }

  getPropertyHandler(propertyName: string): ControlPropertyHandler<any> {
    if (!propertyName) {
      return;
    }

    const handler = this.propertyServices.find((s) => s.propertyName === propertyName);
    if (!handler) {
      return this.defaultPropertyService;
    }
    return handler;
  }
}
